import React, { useEffect, useState } from 'react'
import './Image.css'
import axios from 'axios'
import { getLocalStorage } from '../../utils/helper'

interface ImageProps {
    id: string
    alt?: string
    className?: string
}

const Image: React.FC<ImageProps> = ({ id, alt = '', className = '' }) => {
    const [src, setSrc] = useState<string | null>(null)

    useEffect(() => {
        if (!id) return;
        let cancelled = false;
        const token = getLocalStorage('accessToken') as string;
        axios.get(`${process.env.REACT_APP_API_URL}/master/files/${id}/content`, {
            responseType: 'blob',
            headers: token ? { Authorization: `Bearer ${token}` } : {},
        }).then(res => {
            if (!cancelled) setSrc(URL.createObjectURL(res.data));
        }).catch(() => { /* keep placeholder on error */ });
        return () => { cancelled = true; };
    }, [id])

    return (
        <img
            src={src ?? '/assets/images/no-image-product.png'}
            alt={alt}
            className={className}
        />
    )
}

export default Image
